import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectCleverlynk, selectCleverlynkGroup } from "../redux/slices/cleverlynkSlice";

export default function useFavicon() {
  const group = useSelector(selectCleverlynkGroup);

  const location = useLocation();

  const setFavicon = (path: string, clynkName: string) => {
    const favicon = document.getElementById("favicon");
    const favicon16 = document.getElementById("favicon16");
    const favicon32 = document.getElementById("favicon32");
    const favicon96 = document.getElementById("favicon96");
    const faviconApple120 = document.getElementById("faviconApple120");
    const faviconApple152 = document.getElementById("faviconApple152");
    const faviconApple167 = document.getElementById("faviconApple167");
    const faviconApple180 = document.getElementById("faviconApple180");
    const faviconMs144 = document.getElementById("faviconMs144");
    if (!location.pathname.includes("redirect") && group?.id === "e3a6c0b6-ebac-479a-a183-db8a8447b2b7")
      document.title = "Camión heladero";
    else document.title = clynkName;
    //@ts-ignore
    if (favicon) favicon.href = path;
    //@ts-ignore
    if (favicon16) favicon16.href = path;
    //@ts-ignore
    if (favicon32) favicon32.href = path;
    //@ts-ignore
    if (favicon96) favicon96.href = path;
    //@ts-ignore
    if (faviconApple120) faviconApple120.href = path;
    //@ts-ignore
    if (faviconApple152) faviconApple152.href = path;
    //@ts-ignore
    if (faviconApple167) faviconApple167.href = path;
    //@ts-ignore
    if (faviconApple180) faviconApple180.href = path;
    //@ts-ignore
    if (faviconMs144) faviconMs144.href = path;
  };

  return { setFavicon };
}
